import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getPaywallContext } from "../utils/paywallContext";
import { sendPaywallEvent, trackCardOptionsClick } from "../utils/paywallAnalytics";

const CARD_OPTIONS_TEXTS = [
  "continue with other payment options",
  "credit or debit card",
];

const PaywallAnalyticsRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const route = location.pathname;
    if (route === "/getoffer" || route === "/getofferhair") {
      sendPaywallEvent("upsell_seen", { route });
      return;
    }

    const { paywall } = getPaywallContext(route);
    if (paywall) {
      sendPaywallEvent("paywall_seen", { paywall, route });
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    const handleClick = (event) => {
      const targetText = String(event.target?.textContent || "")
        .trim()
        .toLowerCase();
      if (CARD_OPTIONS_TEXTS.some((text) => targetText.includes(text))) {
        trackCardOptionsClick();
      }
    };

    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, []);

  return null;
};

export default PaywallAnalyticsRouteTracker;
